import React, {Component} from 'react';

class PartNameResults extends Component {
    render() {
        return getSortedChildCategory(this.props.results, 0)
            .map(function (result) {
                return <TopCategoryResult key={result.id} {...this.props} {...result}/>
            }.bind(this))
    }
}

class TopCategoryResult extends Component {
    render() {
        return getSortedChildCategory(this.props.results, this.props.id)
            .map(function (result) {
                return (
                    <GroupCategoryResult key={result.id} {...this.props} {...result}/>
                )
            }.bind(this))
    }
}

class GroupCategoryResult extends Component {
    getChildResults() {
        return getSortedChildCategory(this.props.results, this.props.id)
            .map(function (result) {
                return <p className="link" key={result.id} onClick={() => {this.props.categorySelectAction(result)}}>{getHighlightedText(result.name, this.props.search)}</p>
            }.bind(this))
    }

    render() {
        return (
            <div>
                <h4>{getHighlightedText(this.props.name, this.props.search)}</h4>
                {this.getChildResults()}
            </div>
        );
    }
}

function getSortedChildCategory(results, categoryId) {
    return results.filter(function (result) {
        return result.parent_category_id === categoryId;
    }).sort(function (a, b) {
        return a.position > b.position;
    })
}

function getHighlightedText(text, highlight) {
    let parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return <span> { parts.map((part, i) =>
        <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { color: '#D51D2B' } : {} }>
            { part }
        </span>)
    } </span>;
}


export default PartNameResults;